export const ENV = 'prod';
export const HOMEPAGE_ID = '1384218768';
export const SPACE_ID = 'SHS';
export const SEARCH_TYPE = 'page';
export const GA_ID = 'UA-29841573-2';
export const BASE_URL = `${window.location.protocol}//${
  window.location.hostname
}:${
  process.env.NODE_ENV === 'development' ? '8080' : window.location.port
}/api`;
